import useGetShippingAddress from '@/hooks/order/useGetShippingAddress';
import { Stack, Typography } from '@montugroup/design-system';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Skeleton from '@mui/material/Skeleton';
import { formatShippingAddress } from '../utils.ts';

export type ShippingAddressDetailsProps = {
  orderCode: string;
};

export function ShippingAddressDetails({ orderCode }: ShippingAddressDetailsProps) {
  const { data: shippingAddress, isLoading: isShippingAddressLoading } = useGetShippingAddress(orderCode);

  if (isShippingAddressLoading) {
    return (
      <Skeleton
        data-testid="skeleton-loader"
        variant="rectangular"
        width="100%"
        height={32}
        sx={(theme) => ({ marginBottom: theme.spacing(4) })}
      />
    );
  }

  if (!shippingAddress) {
    return null;
  }

  return (
    <Stack alignItems={'flex-start'} gap={1}>
      <Stack direction={'row'} alignItems={'center'}>
        <LocationOnIcon sx={(theme) => ({ color: theme.palette.secondary.main })} />
        <Typography variant="overline" lineHeight="1.3">
          SHIPPING TO
        </Typography>
      </Stack>
      <Typography variant="body2">{formatShippingAddress(shippingAddress)}</Typography>
    </Stack>
  );
}
